import { render, staticRenderFns } from "./SettingsMenu.vue?vue&type=template&id=75a60884&"
import script from "./settingsMenu.js?vue&type=script&lang=js&"
export * from "./settingsMenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports